import { getAPI, postAPI, putAPI } from "../../api"
import { REACT_APP_JOB, REACT_APP_JOBFILTER } from "../../utils/common"

export async function getPositionsDetails(jobId: string){
    const Details = getAPI( REACT_APP_JOB + `/position/${jobId}`)
    return Details
}

export async function getAppliedCandidate(jobId: string){
    const Details = getAPI( REACT_APP_JOBFILTER + `/resources/${jobId}`)
    return Details
}

export async function updateLossCountAPI(body: any){
    const Details = putAPI(  REACT_APP_JOB + '/loss-count', body)
    return Details
}

export async function updatePositionAPI(body: any){
    const Details = putAPI( REACT_APP_JOB + '/job-status', body)
    return Details
}




